import React, { Component } from "react";
import {
    Message,
    Button,
    Popconfirm,
    Modal,
    Row,
    Col,
    Tag,
    Select,
    FormControl,
    Label,
} from "tinper-bee";
import Layout from "../../pages/Layout";
import * as util from "../../../src/utils/index";
import envList from "./env.json";
import "./index.less";
interface iState {
    name: string;
    version: string;
    env: string;
    envList: Array<any>;
    dcList: Array<any>;
    showModal: boolean;
    dc: string;
}

interface DatacenterGroup {
    DatacenterId: string;
    DatacenterName: string;
    environments: Array<any>;
}

class TNE2nd extends Component<any, iState> {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            version: "",
            env: "pre",
            showModal: false,
            dc: "1",
            dcList: [],
            envList: [],
        };
    }

    async componentDidMount() {
        const arr: DatacenterGroup[] = this.groupByDatacenter(envList);
        let findDc = arr.find(
                (item) => item.DatacenterId === "1"
            );
        this.setState({
            dcList: arr,
            envList: findDc ? findDc.environments : [],
        });
    }

    onChange = (key: string) => (value: string) => {
        this.setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        if (key === "dc") {
            const findDc = (this.state.dcList as DatacenterGroup[]).find(
                (item) => item.DatacenterId === value
            );
            this.setState((prevState) => ({
                ...prevState,
                envList: findDc ? findDc.environments : [],
            }));
        }
    };

    /**
     * 根据 DatacenterId 对环境数据进行分类，并保留数据中心名称
     * @param {Array} envData - 环境数据数组
     * @returns {Array} 按数据中心分组的数组，每个元素包含数据中心信息和环境列表
     */
    groupByDatacenter = (envData: Array<any>): DatacenterGroup[] => {
        const grouped: {[key: string]: DatacenterGroup} = {};

        // 按 DatacenterId 分类
        envData.forEach((item) => {
            const { DatacenterId, DatacenterName } = item;

            if (!grouped[DatacenterId]) {
                grouped[DatacenterId] = {
                    DatacenterId,
                    DatacenterName,
                    environments: [],
                };
            }

            grouped[DatacenterId].environments.push(item);
        });

        // 转换为数组格式返回
        return Object.values(grouped);
    };

    checkUserAuth = () => {
        let localuser = localStorage.getItem("user");
        let userid = localuser ? JSON.parse(localuser).userId : null;
        const userAuthid = [
            "d0fce311-cd38-4f26-b2c5-a01cbd515073",
            "034971ce-348a-4b8d-83ca-f64490da0149",
            "db8aeada-f70c-4be1-ab7e-9b1b26d02d2f",
        ];
        return userAuthid.includes(userid);
    };

    submit = async () => {
        let res1: any = this.checkUserAuth();
        if (!res1) {
            return Message.create({
                content: "您没有更新权限",
                color: "danger",
            });
        }
        let { env } = this.state;
        let res = await util.post("/npm/updateVersionAll", { env });
        if (res.success) {
            Message.create({
                content: res.message,
                color: "success",
                duration: 0,
            });
        } else {
            Message.create({
                content: res.message,
                color: "danger",
                duration: 0,
            });
        }
    };

    render() {
        let { env, dc, dcList, envList } = this.state;
        return (
            <div className="tne2nd">
                <h1>Version-ALL更新</h1>
                <div className="list-item">
                    <Label>数据中心：</Label>
                    <Select
                        value={dc}
                        className="list"
                        onChange={this.onChange("dc")}
                    >
                        {dcList.map((item) => {
                            return (
                                <Select.Option
                                    key={item.DatacenterId}
                                    value={item.DatacenterId}
                                >
                                    {item.DatacenterName}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </div>
                <div className="list-item">
                    <Label>更新环境：</Label>
                    <Select
                        value={env}
                        className="list"
                        onChange={this.onChange("env")}
                    >
                        {envList.map((item) => {
                            return (
                                <Select.Option
                                    key={item.EnvCode}
                                    value={item.EnvCode}
                                >
                                    {item.EnvName}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </div>
                <div className="list-item">
                    <Button onClick={this.submit} colors="primary">
                        提交
                    </Button>
                </div>
            </div>
        );
    }
}

export default Layout(TNE2nd, "tne2nd-page");
